module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"canceled":{"title":"Cancelado","description":"Cobranças que foram autorizadas e depois canceladas.","sales":"cobrança | cobrança | cobranças"}},"en-US":{"canceled":{"title":"Canceled","description":"Charges that have been authorized/captured and then canceled.","sales":"charge | charge | charges"}}}')
  delete Component.options._Ctor
}
